import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import './OrderTrackingPage.css';

const STATUS_STEPS = ['processing','packed','shipped','out_for_delivery','delivered'];
const STATUS_LABELS = { processing:'Order Processing', packed:'Packed', shipped:'Shipped', out_for_delivery:'Out for Delivery', delivered:'Delivered' };

const OrderTrackingPage = () => {
  const { orderId: paramOrderId } = useParams();
  const [orderId, setOrderId] = useState(paramOrderId || '');
  const [tracking, setTracking] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchTracking = async (oid) => {
    setLoading(true); setError(''); setTracking(null);
    try {
      const res = await api.get(`/delivery/track/${oid}`);
      setTracking(res.data.tracking);
    } catch (err) {
      setError('Unable to find tracking info for this order.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (paramOrderId) fetchTracking(paramOrderId); }, [paramOrderId]);

  const currentStep = tracking ? STATUS_STEPS.indexOf(tracking.orderDetails?.deliveryStatus) : -1;

  return (
    <div className="tracking-page">
      <div className="page-header"><h1>Track Your Order</h1></div>
      <div className="container">
        <div className="tracking-container">
          <div className="tracking-search">
            <input
              className="form-input"
              placeholder="Enter Order ID (e.g. SNR000001)"
              value={orderId}
              onChange={e => setOrderId(e.target.value)}
            />
            <button className="btn btn-primary" onClick={() => fetchTracking(orderId)} disabled={!orderId || loading}>
              {loading ? 'Searching...' : 'Track'}
            </button>
          </div>

          {error && <div className="track-error">{error}</div>}

          {tracking && (
            <div className="tracking-result">
              <div className="tracking-header">
                <div><p className="track-label">Order ID</p><h3>{tracking.orderDetails?.orderId}</h3></div>
                {tracking.awb && <div><p className="track-label">AWB No.</p><h3>{tracking.awb}</h3></div>}
                <div><p className="track-label">Current Status</p><h3 className="track-status">{STATUS_LABELS[tracking.orderDetails?.deliveryStatus] || tracking.status}</h3></div>
              </div>

              <div className="tracking-timeline">
                {STATUS_STEPS.map((step, i) => (
                  <div key={step} className={`timeline-step ${i <= currentStep ? 'done' : ''} ${i === currentStep ? 'active' : ''}`}>
                    <div className="timeline-dot">
                      {i <= currentStep ? '✓' : i + 1}
                    </div>
                    <div className="timeline-info">
                      <p className="timeline-label">{STATUS_LABELS[step]}</p>
                    </div>
                    {i < STATUS_STEPS.length - 1 && <div className="timeline-line" />}
                  </div>
                ))}
              </div>

              {tracking.scans?.length > 0 && (
                <div className="tracking-scans">
                  <h3>Delivery Updates</h3>
                  {tracking.scans.slice(0,8).map((scan, i) => (
                    <div key={i} className="scan-item">
                      <span className="scan-dot" />
                      <div>
                        <p className="scan-status">{scan.status}</p>
                        <p className="scan-location">{scan.location} — {scan.date}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderTrackingPage;
